module.exports = __webpack_public_path__ + "08_face.38282982.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer1/08_face.png
// module id = Lygt
// module chunks = 0